import moment from "moment";
import "moment/locale/de";

export const statusVariants = {
  open: "secondary",
  pending: "info",
  prepared: "primary",
  completed: "success",
  closed: "success",
  failed: "danger",
  outdated: "warning",
};

export const monthOptions = moment
  .localeData("de")
  .months()
  .map((monthName, index) => ({
    label: monthName,
    value: index + 1,
  }));

const currentYear = moment().year();

export const yearOptions = Array.from(
  { length: 7 },
  (_, index) => currentYear - 3 + index
);

export function previousMonthPeriod() {
  const previousMonth = moment().subtract(1, "month");

  return {
    month: previousMonth.month() + 1,
    year: previousMonth.year(),
  };
}
